var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._v(" 页面不存在 "),_c('a',{attrs:{"href":"/"}},[_vm._v("返回首页")])])
}]

export { render, staticRenderFns }